import { Dispatch } from 'redux';

import { subscribeToCmsApiSubsite } from 'modules/cms/api/cmsApiSubscribeEndpoints';

import { MainStoreSubscribedSubsitesAction } from './subscribedSubsites';

export function addSubscribedSubsite(subsiteId: string) {
  return (dispatch: Dispatch<MainStoreSubscribedSubsitesAction>) =>
    dispatch({
      type: 'ADD_SUBSCRIBED_SUBSITE',
      subsiteId,
    });
}

export function subscribeToSubsite(subsiteId: string) {
  return (dispatch: Dispatch<MainStoreSubscribedSubsitesAction>) =>
    subscribeToCmsApiSubsite(subsiteId).then(() => {
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      dispatch<any>(addSubscribedSubsite(subsiteId));
    });
}
